import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CarritoPage } from '../carrito/carrito';
import { LoginPage } from '../login/login';
import { Http } from '@angular/http';

@IonicPage()
@Component({
  selector: 'page-articulo',
  templateUrl: 'articulo.html',
})
export class ArticuloPage {
  user;
  producto;
  codigo_art;
  marca;
  modelo;
  tipo;
  precio;
  descr;
  carrito: any;
  img1;
  img2;
  img3;
  img4;
  classImg;
  zoomImg;
  language={};
  constructor(public navCtrl: NavController, public navParams: NavParams, public http: Http) {
    this.http.get('https://ebenlovequickpc.com/i18n/languaje.php?lang='+localStorage.getItem('language')).subscribe((data)=>{
      this.language = data.json();
    })
    this.producto = this.navParams.get('prod');
    this.codigo_art = this.producto.CODIGO_ART;
    this.classImg = "modal-hide";
    this.marca = this.producto.MARCA;
    this.modelo = this.producto.MODELO;
    this.tipo = this.producto.TIPO;
    this.precio = this.producto.PRECIO;
    this.descr = this.producto.DESCR;
    this.user=localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).CODIGO_USER : "";
    this.http.get("http://ebenlovequickpc.com/API/listimg.php?cl=select&codigoart="+this.codigo_art).subscribe((data)=>{
      data.json().map((v,i) => {
        if(v.TIPO === 'portada'){
          this.img1 = data.json()[i].ARCHIVO;
        }else if(v.TIPO === 'descr'){
          this.img2 = data.json()[i].ARCHIVO;
        }else if(v.TIPO === 'imagen1'){
          this.img3 = data.json()[i].ARCHIVO;
        }else{
          this.img4 = data.json()[i].ARCHIVO;
        }
      })
      
      
    });
  }

  ionViewDidLoad() {
  }

  agregar(){
    if(localStorage.getItem("TOKEN")){
     let params = "codigo_art="+this.codigo_art+"&codigo_user="+this.user;
     this.http.get("https://ebenlovequickpc.com/API/carrito.php?cl=insert&"+params).subscribe((date)=>{
        this.navCtrl.setRoot(CarritoPage);
     });
    }else{
      this.navCtrl.push(LoginPage);
    }

  }

  imgZoom(img){
    this.classImg = "modal-img";
    this.zoomImg = img;
  }
  hideModal(){
    this.classImg = "modal-hide";
    this.zoomImg = '';
  }

}



// WEBPACK FOOTER //
// ./src/pages/articulo/articulo.ts